import $ from 'jquery';

// Scroll to accordion scroll target when any of its collapses are expanding
$('.accordion .collapse').on('show.bs.collapse', function (e) {

  const scrollTargetElement = $(this).closest('.accordion-scroll-target').get(0);

  if (scrollTargetElement) {
    scrollTargetElement.scrollIntoView({
      behavior: 'smooth'
    });
  }

});